/*
 *
 * ChannelsPage
 *
 */

import React from 'react';
import { connect } from 'react-redux';
import { postChannelRequest } from './actions';
import { createStructuredSelector } from 'reselect';
import { isString, isObject } from 'utils/helpers';
import Forms from './Forms';
import {
  selectAllChannels,
  selectClients,
  selectChannelFormLogo,
  selectChannelFormBackground,
  selectChannelFormGalleryBackground,
  selectBrandFormData,
  selectMessageFormData,
  selectChannelFormThemeId,
} from './selectors';
const urlFix = (url) => url && url.slice(-11) !== 'missing.png' ? url : null;
const makeUrl = (file) => window.URL.createObjectURL(file);
const NewChannel = ({ location: { pathname }, ...props}) => {
  const {
    postChannel,
    channels,
    match: { params: { channelId }},
    channelFormLogo,
    channelFormBackground,
    galleryColor,
    brandForm,
    messageForm,
    themeId,
    } = props;

  let channel = channelId && channels ? channels[channelId] : null;

  const logoImage = isObject(channelFormLogo)
    ? makeUrl(channelFormLogo[0])
    : channel && urlFix(channel.big_logo_image_url);
  const overlayImage = isObject(channelFormBackground)
    ? makeUrl(channelFormBackground[0])
    : channel && urlFix(channel.overlay_image_url);
  const backgroundColor = isString(channelFormBackground)
    ? channelFormBackground
    : channel && channel.app_background_color;

  const bgColorChanged =
    isString(channelFormBackground)
    && !isObject(channelFormBackground);
  const overlayChanged =
    isObject(channelFormBackground)
    && !isString(channelFormBackground);

  const previewProps = {
    logoImage,
    overlayImage,
    backgroundColor,
    bgColorChanged,
    overlayChanged,
    galleryColor,
    brandForm,
    messageForm,
    themeId,
  };
  return (
  <Forms isNew title="New Channel" {...previewProps} onSubmit={postChannel} />
);}

const mapStateToProps = createStructuredSelector({
  channels: selectAllChannels(),
  clients: selectClients(),
  channelFormLogo: selectChannelFormLogo(),
  channelFormBackground: selectChannelFormBackground(),
  brandForm: selectBrandFormData(),
  messageForm: selectMessageFormData(),
  galleryColor: selectChannelFormGalleryBackground(),
  themeId: selectChannelFormThemeId(),
});

const mapDispatchToProps = (dispatch) => ({
  postChannel: (payload) => dispatch(postChannelRequest(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewChannel);



// WEBPACK FOOTER //
// ./src/containers/ChannelsPage/NewChannel.js